import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAR47/BAR47_QuickQuiz_v4',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAR47/BAR47_YourMistakes_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>\n' +
      '\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAR47/BAR47_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    MixedOnlineTests: [],

    ButtonURL: 'video-explanations',
    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our Science experts break down key concepts for you — even the tricky bits!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '/assets/images/useful-bits-toucan.png',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic 1a — Cells and Microscopy',
            Subcategories: [
              {
                Name: 'The Cell Cycle and Mitosis',
                ShortName: 'The-Cell-Cycle-and-Mitosis',
                Link: 'https://www.youtube.com/embed/5zSL1xQ9tOc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 1b — Exchanging Substances',
            Subcategories: [
              {
                Name: 'Diffusion',
                ShortName: 'Diffusion',
                Link: 'https://www.youtube.com/embed/TahOKtPHrl4?rel=0&modestbranding=1',
              },
              {
                Name: 'Osmosis',
                ShortName: 'Osmosis',
                Link: 'https://www.youtube.com/embed/CizgcfyOFoY?rel=0&modestbranding=1',
              },
              {
                Name: 'Active Transport in the Gut',
                ShortName: 'Active-Transport-in-the-Gut',
                Link: 'https://www.youtube.com/embed/qluo1t2JKAc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Organisation, Enzymes and Circulation',
            Subcategories: [
              {
                Name: 'Enzymes',
                ShortName: 'Enzymes',
                Link: 'https://www.youtube.com/embed/9cMF8qJdaFI?rel=0&modestbranding=1',
              },
              {
                Name: 'Gas Exchange',
                ShortName: 'Gas-Exchange',
                Link: 'https://www.youtube.com/embed/-QAeAfQ8hjo?rel=0&modestbranding=1',
              },
              {
                Name: 'The Double Circulatory System',
                ShortName: 'The-Double-Circulatory-System',
                Link: 'https://www.youtube.com/embed/GcDgKpxvCX8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Transpiration',
                ShortName: 'Transpiration',
                Link: 'https://www.youtube.com/embed/2rCNRcUp8rQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Infection and Response',
            Subcategories: [
              {
                Name: 'Vaccinations',
                ShortName: 'Vaccinations',
                Link: 'https://www.youtube.com/embed/KawDHstCjWw?rel=0&modestbranding=1',
              },
              {
                Name: 'Producing Monoclonal Antibodies',
                ShortName: 'Producing-Monoclonal-Antibodies',
                Link: 'https://www.youtube.com/embed/vzcIn01G8Bc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5a — The Nervous System',
            Subcategories: [
              {
                Name: 'Reflexes',
                ShortName: 'Reflexes',
                Link: 'https://www.youtube.com/embed/aBHUttz6fYY?rel=0&modestbranding=1',
              },
              {
                Name: 'modation',
                ShortName: 'Accommodation',
                Link: 'https://www.youtube.com/embed/nCqCa5hJeNo?rel=0&modestbranding=1',
              },
              {
                Name: 'Correcting Vision',
                ShortName: 'Correcting-Vision',
                Link: 'https://www.youtube.com/embed/abw1cu2B748?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Hormones',
            Subcategories: [
              {
                Name: 'Controlling Blood Glucose',
                ShortName: 'Controlling-Blood-Glucose',
                Link: 'https://www.youtube.com/embed/gDGWhj8KbHc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'Meiosis',
                ShortName: 'Meiosis',
                Link: 'https://www.youtube.com/embed/-XqX5djlSdA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Variation, Evolution and Classification',
            Subcategories: [
              {
                Name: 'Speciation',
                ShortName: 'Speciation',
                Link: 'https://www.youtube.com/embed/WSKpQsbCFRo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7a — Ecology and Cycles',
            Subcategories: [
              {
                Name: 'The Water Cycle',
                ShortName: 'The-Water-Cycle',
                Link: 'https://www.youtube.com/embed/bjD0aUj20SM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],

    ButtonURL: 'content-videos',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '/assets/images/useful-bits-toucan.png',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic 1a — Cells and Microscopy',
            Subcategories: [
              {
                Name: 'Magnification',
                ShortName: 'Magnification',
                Link: 'https://www.youtube.com/embed/MEREsZWMRZE?rel=0&modestbranding=1',
              },
              {
                Name: 'Mitosis',
                ShortName: 'Mitosis',
                Link: 'https://www.youtube.com/embed/B9GedI8mWbQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Binary Fission',
                ShortName: 'Binary-Fission',
                Link: 'https://www.youtube.com/embed/jvPqYtINPqs?rel=0&modestbranding=1',
              },
              {
                Name: 'Inhibition Zones',
                ShortName: 'Inhibition-Zones',
                Link: 'https://www.youtube.com/embed/-w3UJt-iAmM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 1b — Exchanging Substances',
            Subcategories: [
              {
                Name: 'Diffusion',
                ShortName: 'Diffusion',
                Link: 'https://www.youtube.com/embed/hEcfOMmvYdk?rel=0&modestbranding=1',
              },
              {
                Name: 'Surface Area to Volume Ratios',
                ShortName: 'Surface-Area-to-Volume-Ratios',
                Link: 'https://www.youtube.com/embed/StPUz-sn4Q8?rel=0&modestbranding=1',
              },
              {
                Name: 'Exchange Surfaces',
                ShortName: 'Exchange-Surfaces',
                Link: 'https://www.youtube.com/embed/TQIOFgRNL1A?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Organisation, Enzymes and Circulation',
            Subcategories: [
              {
                Name: 'The Rate of Enzyme Activity',
                ShortName: 'The-Rate-of-Enzyme-Activity',
                Link: 'https://www.youtube.com/embed/RCAVgXzxadk?rel=0&modestbranding=1',
              },
              {
                Name: 'The Rate of Blood Flow',
                ShortName: 'The-Rate-of-Blood-Flow',
                Link: 'https://www.youtube.com/embed/wW-aZvUHCmY?rel=0&modestbranding=1',
              },
              {
                Name: 'Blood Cells',
                ShortName: 'Blood-Cells',
                Link: 'https://www.youtube.com/embed/1Ec_ytkhTiU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Transpiration',
                ShortName: 'Transpiration',
                Link: 'https://www.youtube.com/embed/QrGlRhXJxMc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Infection and Response',
            Subcategories: [
              {
                Name: 'Vaccination',
                ShortName: 'Vaccination',
                Link: 'https://www.youtube.com/embed/-ydxd0-zD0A?rel=0&modestbranding=1',
              },
              {
                Name: 'Monoclonal Antibodies',
                ShortName: 'Monoclonal-Antibodies',
                Link: 'https://www.youtube.com/embed/6AimFHu2hm4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Bioenergetics',
            Subcategories: [
              {
                Name: 'The Inverse Square Law',
                ShortName: 'The-Inverse-Square-Law',
                Link: 'https://www.youtube.com/embed/0oNV3p-7qRg?rel=0&modestbranding=1',
              },
              {
                Name: 'Exercise',
                ShortName: 'Exercise',
                Link: 'https://www.youtube.com/embed/sgFsHWcGXEM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic 5a — The Nervous System',
            Subcategories: [
              {
                Name: 'Reflex Reactions',
                ShortName: 'Reflex-Reactions',
                Link: 'https://www.youtube.com/embed/uTGmrc0w6C8?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Reaction Time',
                ShortName: 'Investigating-Reaction-Time',
                Link: 'https://www.youtube.com/embed/rze8YclL-KQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Hormones',
            Subcategories: [
              {
                Name: 'Controlling Blood Glucose',
                ShortName: 'Controlling-Blood-Glucose',
                Link: 'https://www.youtube.com/embed/NBRD8no24hM?rel=0&modestbranding=1',
              },
              {
                Name: 'ADH',
                ShortName: 'ADH',
                Link: 'https://www.youtube.com/embed/HQnzWKSpa00?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'The Structure of DNA',
                ShortName: 'The-Structure-of-DNA',
                Link: 'https://www.youtube.com/embed/eO3-Se0nXmQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Meiosis',
                ShortName: 'Meiosis',
                Link: 'https://www.youtube.com/embed/Fmz0jp0ipRo?rel=0&modestbranding=1',
              },
              {
                Name: 'Genetic Diagrams',
                ShortName: 'Genetic-Diagrams',
                Link: 'https://www.youtube.com/embed/QNHp9lued1c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Variation, Evolution and Classification',
            Subcategories: [
              {
                Name: 'Evolution',
                ShortName: 'Evolution',
                Link: 'https://www.youtube.com/embed/cAyK4Aj3_Lc?rel=0&modestbranding=1',
              },
              {
                Name: 'Selective Breeding',
                ShortName: 'Selective-Breeding',
                Link: 'https://www.youtube.com/embed/_AzxzW3IkFU?rel=0&modestbranding=1',
              },
              {
                Name: 'Evolutionary Trees',
                ShortName: 'Evolutionary-Trees',
                Link: 'https://www.youtube.com/embed/hcC1s_4MPXg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7a — Ecology and Cycles',
            Subcategories: [
              {
                Name: 'Interdependence',
                ShortName: 'Interdependence',
                Link: 'https://www.youtube.com/embed/7lpQWU0Xo1s?rel=0&modestbranding=1',
              },
              {
                Name: 'Adaptations',
                ShortName: 'Adaptations',
                Link: 'https://www.youtube.com/embed/A7axAA5r14g?rel=0&modestbranding=1',
              },
              {
                Name: 'Food Chains',
                ShortName: 'Food-Chains',
                Link: 'https://www.youtube.com/embed/zR-fzoN-xts?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Quadrats',
                ShortName: 'Using-Quadrats',
                Link: 'https://www.youtube.com/embed/YGvbA0n48YU?rel=0&modestbranding=1',
              },
              {
                Name: 'Rate of Decay',
                ShortName: 'Rate-of-Decay',
                Link: 'https://www.youtube.com/embed/YITbiuZQ4Us?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7b — Ecosystems, Biodiversity & Food Production',
            Subcategories: [
              {
                Name: 'Pyramids of Biomass',
                ShortName: 'Pyramids-of-Biomass',
                Link: 'https://www.youtube.com/embed/YmyP5TnbNRw?rel=0&modestbranding=1',
              },
              {
                Name: 'Biomass Transfer',
                ShortName: 'Biomass-Transfer',
                Link: 'https://www.youtube.com/embed/W9ceqk2HGog?rel=0&modestbranding=1',
              },
              {
                Name: 'Biotechnology',
                ShortName: 'Biotechnology',
                Link: 'https://www.youtube.com/embed/lbze517n4ns?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#0993A3',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: 'GCSE Biology',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#E04693',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, resource sheets, exam tips and a glossary... yep, it\'s all right here.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your printable answers, resource sheets, exam tips and more are all below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/BAR47/PDFs/cgp-gcse-biology-commandwords.pdf" target="_blank">Command Word Glossary</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/BAR47/PDFs/cgp-gcse-biology-examrules.pdf" target="_blank">Golden Rules for Your Exam</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/BAR47/PDFs/cgp-gcse-biology-diagrams-higher.pdf" target="_blank">Key Diagrams</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/BAR47/PDFs/cgp-gcse-biology-summaryanswers-higher.pdf" target="_blank">Revision Summary Test Answers</a></p>\n',
      ContentRight: {
        ImageUrl: '/assets/images/useful-bits-toucan.png',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        "We've put together lots of helpful information on how to get the most out of your Complete Revision & Practice. And if you've hit any snags, you'll find the answers you need here too. Très bien!",
      Text:
        '  <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science books. Use the quizzes, tests, videos and more to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the key facts, maths skills and practical skills on the course. There's one on almost every page of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.</p>\n" +
        '\n' +
        "<p>Revision Summary Tests include more challenging questions — if you can do them all, you'll know you've covered everything. You'll find one at the end of every section in your book and you can mark them yourself using our example answers.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. Check out the How To Revise page in your RevisionHub if you want more top revision tips before your exams.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/sURtVqRez6Q?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from! Take a look at some of our other revision books.",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];

